/**
 * @file Sun icon for the light-theme half of the theme toggle.
 * @module @labcraft/ui/icons/sun
 *
 * Inline SVG inheriting `currentColor`. Consumers control size via
 * `width`/`height` props or CSS, color via `color` on a parent.
 */

import type { JSX, SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

/**
 * Sun icon.
 *
 * @param props - Pass-through props for the underlying `<svg>`.
 * @returns The rendered icon.
 */
export function SunIcon(props: IconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      width={14}
      height={14}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}>
      <circle cx={12} cy={12} r={4} />
      <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </svg>
  )
}
